import React, { Component } from 'react';
import '../ddsu5168/index.scss';

class MeterProductPage extends Component {
  constructor(props) {
    super(props);
    this.state = { scale: 1 };
  }

  componentDidMount() {
    document.title = this.props.documentTitle;
    this.fitPage();
    window.addEventListener('resize', this.fitPage);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.fitPage);
  }

  fitPage = () => {
    const scale = Math.min(window.innerWidth / 1080, window.innerHeight / 1920, 1);
    this.setState({ scale });
  };

  render() {
    const {
      bgImg,
      logoImg,
      productImg,
      qrImg,
      model,
      productName,
      slogan,
      tags,
      manualUrl,
      wiringUrl,
      productImageStyle,
      secondaryTitle = '查看接线图',
      secondarySubtitle = 'WIRING GUIDE · 点击查看 →',
      secondaryLinkTitle = `查看 ${model} 接线图`
    } = this.props;
    const { scale } = this.state;

    return (
      <div className="ddsu5168-interactive-wrapper">
        <div
          id="viewport"
          style={{ width: `${1080 * scale}px`, height: `${1920 * scale}px` }}
        >
          <main className="page" id="page" style={{ transform: `scale(${scale})` }}>
            <img className="background" src={bgImg} alt="产品服务页面背景" />
            <img className="logo" src={logoImg} alt="源一物联" />

            <section className="copy">
              <div className="model-top">{model}</div>
              <h1>{productName}</h1>
              <div className="slogan">{slogan}</div>
              <div className="tags">
                {tags.map((tag) => <div className="tag" key={tag}>{tag}</div>)}
              </div>
            </section>

            <section className="product-zone">
              <img
                className="product"
                src={productImg}
                alt={`${model} ${productName}`}
                style={productImageStyle}
              />
            </section>

            <footer className="footer">
              <div className="footer-top">
                <div className="support">
                  <strong>{manualUrl ? '说明书与安装服务' : '接线安装服务'}</strong>
                  <span>{manualUrl ? '点击下方入口，快速查看对应资料' : '点击下方入口，查看专业接线图'}</span>
                </div>
                <div className="qr-wrap">
                  <img className="qr" src={qrImg} alt="源一物联公众号二维码" />
                </div>
              </div>

              <div className={`actions${manualUrl ? '' : ' is-single'}`}>
                {manualUrl && (
                  <a
                    className="action"
                    href={manualUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={`打开 ${model} 使用说明`}
                  >
                    <div className="icon">
                      <svg viewBox="0 0 24 24">
                        <path d="M6 3h9l3 3v15H6z" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M15 3v4h4M9 11h6M9 15h6" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                    <div>
                      <b>查看使用说明</b>
                      <span>USER GUIDE · 点击打开 ↗</span>
                    </div>
                  </a>
                )}

                <a className="action" href={wiringUrl} title={secondaryLinkTitle}>
                  <div className="icon">
                    <svg viewBox="0 0 24 24">
                      <path d="M12 3 2.8 20h18.4z" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M12 9v5M12 17.5v.2" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <div>
                    <b>{secondaryTitle}</b>
                    <span>{secondarySubtitle}</span>
                  </div>
                </a>
              </div>
            </footer>
          </main>
        </div>
      </div>
    );
  }
}

export default MeterProductPage;
